export default "__VITE_ASSET__Tf7GT3CV__"